import React from 'react';
import { Switch, Route } from "react-router-dom";
import App from "./App";
import Group from './Group';
import Team from "./Team";

const Router: React.FC = () => {
    return (
        <Switch>
            <Route path="/" exact={true}>
                <App />
            </Route>
            <Route path="/about" exact={true}>
                <App />
            </Route>
            <Route path="/group/:groupId" exact={true}>
                <Group />
            </Route>
            <Route path="/group/:groupId/team/:teamId" exact={true}>
                <Team />
            </Route>
        </Switch>
    );
}

export default Router;